export default __webpack_public_path__ + "static/media/jee_mock_modal_mobile.d00cf8ce.png";